import { render } from "./mat-formfield.vue?vue&type=template&id=57a09911&lang=true"
import script from "./mat-formfield.vue?vue&type=script&lang=js"
export * from "./mat-formfield.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__